import { request, gatewayRsRequest } from './index';

export interface IWechatLoginRequest {
  code: string;
  // WECHAT_PG 微信公众号， WECHAT_PG_APPLET 小程序
  oauthType?: string;
}

export interface IWechatLoginResponse {
  token: string;
  content?: {
    token?: string;
    openId?: string;
    unionId?: string;
    uuid?: string;
    displayPhone?: boolean;
    email?: string;
    phone?: string;
  };
}

export interface WXAppletQRCodeReq {
  path: string;
  width?: number;
}

// 电商微信公众号登录接口
export const wechatLogin = (params: IWechatLoginRequest) => {
  return gatewayRsRequest.post<IWechatLoginResponse, IWechatLoginResponse>(`/public/authentication/loginCode`, {
    ...params,
  });
};
export interface IWechatConfigResponse {
  appId: string;
  nonce: string;
  signature: string;
  timestamp: number;
}
// 获取微信签名信息
export const getWeixinSign = (params: string) => {
  return request.get<IWechatConfigResponse, IWechatConfigResponse>(
    `/public/api/wechat/share/js/sdk/config?url=${encodeURIComponent(params)}`,
  );
};

// 仅获取UnionID public/auth/ec/getWechatUserInfo/{code}          get请求； cp-public服务
export const wechatLogin2 = (params: IWechatLoginRequest) => {
  return request.get<IWechatLoginResponse, IWechatLoginResponse>(
    `/public/auth/ec/getWechatUserInfo/${params.code}`,
    {},
  );
};
